// src/hooks/usePageTitle.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitleMap = {
    "/dashboard": "Dashboard",

    "/manage-branch": "Manage Branch",
    "/manage-area": "Manage Area",
    "/manage-delivery-point": "Manage Delivery Point",

    "/manage-products": "Manage Products",
    "/manage-packages": "Manage Packages",

    "/manage-lead": "Manage Lead",
    "/manage-coupon": "Manage Coupon",

    "/manage-subscribers": "Manage Subscriber",

    "/manage-subscriptions": "Manage Subscription",
    "/manage-drop": "Manage Drop",

    "/manage-payments": "Manage Payments",
    "/manage-refund": "Manage Refund",

    "/manage-items": "Manage Items",
    "/menu-maker": "Menu Maker",
    "/manage-daily-orders": "Manage Daily Orders",
    "/manage-work-assignment": "Manage Work Assignment",
    "/manage-quality-analysis": "Manage Quality Analysis",
    "/manage-wastage": "Manage Wastage",
    "/manage-production-costing": "Manage Production Costing",

    "/manage-rawmaterials": "Manage Raw Material",
    "/manage-vendors": "Manage Vendor",
    "/manage-purchase": "Manage Purchase",
    "/purchase-history": "Purchase History",
    "/manage-stocks": "Manage Stock",
    "/manage-pricebook": "Manage Pricebook",

    "/manage-tripsheet": "Manage Tripsheet",
    "/manage-delivery": "Manage Delivery",

    "/manage-complaints": "Manage Compliants",

    "/manage-vehicles": "Manage Vehicle",
    "/manage-maintenance": "Manage Maintenance",

    "/manage-staff": "Manage Staff",
    "/manage-attendance": "Manage Attendance",
    "/manage-payouts": "Manage Payouts",

    "/daily-accounts": "Daily Accounts",
    "/profit-loss": "Profit-Loss",
    "/trial-balance": "Trial Balance",

    "/manage-users": "Manage Users",

    "/settings": "Settings"

    // Add other routes here as needed
};

export function usePageTitle() {
    const location = useLocation();

    useEffect(() => {
        const title = routeTitleMap[location.pathname] || "Atchayapathra Foods";
        document.title = `${title} - Atchayapathra Foods`;
    }, [location]);
}
